(() => {
  const pauseOtherVideos = (currentVideo) => {
    document.querySelectorAll('[data-mypc-benchmarks] video').forEach((video) => {
      if (video !== currentVideo && !video.paused) video.pause();
    });
  };

  const updateControls = (root) => {
    const track = root.querySelector('[data-mypc-benchmark-track]');
    const controls = root.querySelector('[data-mypc-benchmark-controls]');
    const previous = root.querySelector('[data-mypc-benchmark-prev]');
    const next = root.querySelector('[data-mypc-benchmark-next]');
    if (!track || !controls || !previous || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    controls.hidden = maxScroll < 2;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  };

  const scrollTrack = (root, direction) => {
    const track = root.querySelector('[data-mypc-benchmark-track]');
    const card = track?.querySelector('[data-mypc-benchmark-card]');
    if (!track || !card) return;

    const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  };

  const loadVideo = (button) => {
    const card = button.closest('[data-mypc-benchmark-card]');
    const media = card?.querySelector('[data-mypc-benchmark-media]');
    const template = media?.querySelector('[data-mypc-video-template]');
    if (!card || !media || !template) return;

    pauseOtherVideos(null);
    const fragment = template.content.cloneNode(true);
    const video = fragment.querySelector('video');
    if (!video) return;

    media.replaceChildren(fragment);
    video.addEventListener('play', () => pauseOtherVideos(video));
    video.play().catch(() => {
      // Los controles quedan disponibles si el navegador bloquea la reproducción automática.
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mypc-benchmarks]').forEach((root) => {
      if (root.dataset.mypcInitialized === 'true') return;
      root.dataset.mypcInitialized = 'true';

      root.addEventListener('click', (event) => {
        const playButton = event.target.closest('[data-mypc-video-load]');
        if (playButton) {
          loadVideo(playButton);
          return;
        }

        if (event.target.closest('[data-mypc-benchmark-prev]')) scrollTrack(root, -1);
        if (event.target.closest('[data-mypc-benchmark-next]')) scrollTrack(root, 1);
      });

      const track = root.querySelector('[data-mypc-benchmark-track]');
      let animationFrame;
      track?.addEventListener('scroll', () => {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(() => updateControls(root));
      }, { passive: true });

      updateControls(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-mypc-benchmarks]').forEach((root) => updateControls(root));
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pauseOtherVideos(null);
  });
})();
